export enum AddressType {
  ADDR = 'ADDR',
  BIZZ = 'BIZZ',
  DLVY = 'DLVY',
  HOME = 'HOME',
  MLTO = 'MLTO',
  PBOX = 'PBOX',
}
